import { ModelBase } from "@shoothill/core";
import { makeObservable, observable } from "mobx";
import { Validator } from "Application/Validation";

export class CustomercareModel extends ModelBase<CustomercareModel> {
    constructor() {
        super();
        makeObservable(this, {});
    }
}

export class CustomercareModelValidator extends Validator<CustomercareModel> {
    constructor() {
        super();
        //this.ruleFor("id").notEmpty();
    }
}
